// extracted by mini-css-extract-plugin
export default {"wrapper":"GetFullAccess_wrapper__-WlRq","content":"GetFullAccess_content__icq++","title":"GetFullAccess_title__gztwJ","text":"GetFullAccess_text__tIFzm"};